import script from "./SyncOpDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncOpDetails.vue?vue&type=script&setup=true&lang=ts"

import "./SyncOpDetails.vue?vue&type=style&index=0&id=2dd4cb6c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dd4cb6c"]])

export default __exports__